import { render, staticRenderFns } from "./AdminSetting.vue?vue&type=template&id=343ca0cc&scoped=true"
import script from "./AdminSetting.vue?vue&type=script&lang=js"
export * from "./AdminSetting.vue?vue&type=script&lang=js"
import style0 from "./AdminSetting.vue?vue&type=style&index=0&id=343ca0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343ca0cc",
  null
  
)

export default component.exports